module.exports = __webpack_public_path__ + "static/media/Marcello L..bead31ff.png";